


















import { Component, Vue } from "vue-property-decorator";
import DefaultWelcomeImg from './RightSide/DefaultWelcomeImg.vue';

@Component({ components: { DefaultWelcomeImg } })
export default class RightSide extends Vue {
    get homeScreenImage() {
        // 'sovkom_welcome'
        const imgName = this.$store.direct.state.widget?.homeScreenImage;
        if (!imgName)
            return null;

        try {
            const img = require(`./assets/${imgName}.png`);
            return img;
        } catch {
            console.warn('img not found, use default');
            return null;
        }
    }
}
